import {
  VACS_FETCH,
  VACS_FETCH_FOR_LITTER,
  VACS_ADD,
  VACS_UPDATE,
  VACS_DELETE,
  VACS_ADD_FOR_LITTER,
  AUTH_LOG_OUT_USER,
  TRANSFERS_UPDATE_PET_AND_TRANSFER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetched: [],
};

export default function VacsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case VACS_FETCH:
      return {
        ...state,
        entries: _.uniqWith([...state.entries, ...action.payload], _.isEqual),
        fetched: [...state.fetched, action.pet._id],
      };
    case VACS_FETCH_FOR_LITTER:
      return {
        ...state,
        entries: _.uniqWith([...state.entries, ...action.payload], _.isEqual),
        fetched: [...state.fetched, action._litter],
      };
    case VACS_ADD:
      return {
        ...state,
        entries: _.sortBy([...state.entries, action.payload], "date").reverse(),
      };
    case VACS_ADD_FOR_LITTER:
      return {
        ...state,
        entries: _.sortBy(
          [...state.entries, ...action.payload],
          "date"
        ).reverse(),
      };
    case VACS_UPDATE:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "date"
        ),
      };
    case VACS_DELETE:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case TRANSFERS_UPDATE_PET_AND_TRANSFER:
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
